import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'futureDates',
    standalone: true
})
export class FutureDatesPipe implements PipeTransform {
    transform(items: any): any {
        const arrayToReturn: any = [];
        for (let i = 0; i < items.length; i++) {
            const date = items[ i ].startTime;
            if (moment(date).isAfter(moment())) {
                arrayToReturn.push(items[ i ]);
            }
        }
        return arrayToReturn;
    }
}
